module.exports = __webpack_public_path__ + "static/media/pro3.a0cc365b.jpg";